import React from 'react'
import { Link } from 'react-router-dom';
import catimg from '../img/category-1.png'

export default function CategoryCard() {
  return (
    <div>
        <div className='box-container'>
        <div className="card" style={{ width: "18rem"}}>
          <div className="card-body">
            <h5 className="card-title">Upto 50% Off</h5>
            <img className='images' src={catimg} alt="img"/>
            <Link to="#" className="btn all-btn button">Shop Now</Link>
          </div>
        </div>
      </div>
    </div>
  )
}
